import LoginForm from "./LoginForm"

const LoginScreen = ({show, onClose, loginCallback, ...props}) => {
    let className = show? "login-screen login-screen--show" : "login-screen" 
    
    return <div className={className}>
        {
            !show ? null : <div className="btn-close" onClick={onClose} style={{color: "white"}}>X</div>
        }


        <LoginForm onComplete={loginCallback}/>
    </div>
}

export default LoginScreen